import React, { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import moment from 'moment-timezone';
import { CalendarIcon, ChartBarIcon } from '@heroicons/react/24/outline';
import Tooltip from '../../../components/Tooltip';

export default function Filled(props) {
  const { event } = props;

  const [timestamp] = useState(moment().toISOString());

  const invitations = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          response: 'Yes',
          eventId: event.id,
          createdAt: {
            $lte: timestamp
          }
        }
      }
    },
    pagination: {
      pageSize: 1000
    }
  });

  if (invitations.state === PayloadStates.FETCHING) {
    return (
      <div className="flex space-x-1 items-center text-gray-500 text-sm">
        <Tooltip tooltip="Percent filled" icon={false}>
          <ChartBarIcon className="h-6 w-6" />
        </Tooltip>
        <span>
          ...
        </span>
      </div>
    );
  }

  if (!event.data.slots) {
    return (
      <div className="flex space-x-1 items-center text-gray-500 text-sm">
        <Tooltip tooltip="Percent filled" icon={false}>
          <ChartBarIcon className="h-6 w-6" />
        </Tooltip>
        <span>
          ?
        </span>
      </div>
    );
  }
  const percent = Math.floor(invitations.data.length / event.data.slots * 100);

  return (
    <div className="flex space-x-1 items-center text-gray-500 text-sm">
      <Tooltip tooltip="Percent filled" icon={false}>
        <ChartBarIcon className="h-6 w-6" />
      </Tooltip>
      <span>
        {percent}%
      </span>
    </div>
  );
}
